import { handleActions } from 'redux-actions';

import * as constants from './constants';

export const initialState = {
  organizationId: 0,
  isNewLocationShowed: false,
};

function openNewLocationModal(state, { payload }) {
  const organizationId = payload;

  return {
    ...state,
    isNewLocationShowed: true,
    organizationId,
  };
}

function closeNewLocationModal(state) {
  return {
    ...state,
    isNewLocationShowed: false,
  };
}

export default handleActions(
  {
    [constants.OPEN_NEW_LOCATION_MODAL]: openNewLocationModal,
    [constants.CLOSE_NEW_LOCATION_MODAL]: closeNewLocationModal,
  },
  initialState
);
